import React, { useState, useEffect } from 'react';
import { Grid, FormControl, InputLabel, MenuItem, Typography, Button } from '@mui/material';
import styled from '@mui/material/styles/styled';
import { UseScreen } from '../hooks/UseScreen.hook';
import { useDispatch, useSelector } from 'react-redux';
import SuccessModal from '../components/SuccessModal';
import { useNavigate } from 'react-router-dom';
import { DailyReportTable, ServicesReport } from '../components/datatables/index'
import { PrimaryLightSelect, PrimaryButton } from '../theme/index';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { reportTypeAction, tableTypeAction } from '../redux/reducers/Report';

const Room = styled(Grid)(({ theme }) => `
    :hover{
      cursor: pointer
    }
`)

const createReservationRoute = '/bookings';

const DailyReport = () => {

  const screenWidth = UseScreen();
  const dispatch = useDispatch();
  const modalStatus = useSelector( state => state.Modal.modalState );
  const navigate = useNavigate();
  const [table, setTable] = useState('room');
  const [report, setReport] = useState('/dailyreport');

  const reportType = useSelector( state => state.Report.reportType );
  const tableType = useSelector( state => state.Report.tableType );

  useEffect( () => {
    setTable(tableType);
  }, [tableType] );

  useEffect( () => {
    setReport(reportType);
  }, [reportType] );

  const [ showModal, setShowModal ] = useState(false);

  const btnFilter = () => {
    return ( screenWidth <= 500 ) ? { width: '100%', marginBottom: '1rem' } : { width: '90%' };
  }

  useEffect( () => {
    setShowModal(modalStatus);
  }, [modalStatus] );

  const tablesTitle = () => {
    return ( screenWidth <= 500 ) ? { fontSize: '1.5rem', fontFamily: 'Roboto-Bold'  } : { fontSize: '2rem', fontFamily: 'Roboto-Bold'  };
  }

  const changeReportType = (value) => {
    dispatch(reportTypeAction(value));
    navigate(value);
  }
  
  return (
    <Grid container px={4}>
      <Grid item xs={12}>
        <h2 style={{ fontFamily: 'Roboto-Thin' }}>Reporte diario</h2>
      </Grid>

      <Grid container sx={{ justifyContent: 'space-between' }}>
        <Grid item xs={12} sm={3} md={2}>
          <FormControl sx={btnFilter()}>
            <InputLabel id="demo-simple-select-label">Tipo reporte</InputLabel>
            <PrimaryLightSelect 
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Nivel"
              onChange={ e => changeReportType(e.target.value) }
              value={ reportType }
            >
                <MenuItem value='/dailyreport'>Diario</MenuItem>
                <MenuItem value='/dailyreportuser'>Mi usuario</MenuItem>
                <MenuItem value='/dailyreportcash'>Caja</MenuItem>
            </PrimaryLightSelect>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={3} md={2}>
          <FormControl sx={btnFilter()}>
            <InputLabel id="demo-simple-select-label">Tipo de tabla</InputLabel>
            <PrimaryLightSelect 
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Tipo de habitacion"
              onChange={ e => dispatch(tableTypeAction(e.target.value)) }
              value={ tableType }
            >
                <MenuItem value='room'>Tabla de alquiler</MenuItem>
                <MenuItem value='services'>Tabla servicios a la habitación</MenuItem>
            </PrimaryLightSelect>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={8} sx={ (theme) => ({ display: 'flex', alignItems: 'center', justifyContent: 'end' }) }>
          <Typography>
            <b>Fecha:</b>
          </Typography>
          <Typography sx={ (theme) => ({ ml: 2, color: `${theme.palette.secondary.main}`}) }>
            07/03/2022
          </Typography>
        </Grid>
      </Grid>

      <Grid container sx={{ justifyContent: 'end' }}>
        <Grid item xs={12} sm={4} md={2} sx={{ mb: 2, mt: 8, textAlign: 'end', justifyContent: 'end' }}>
          <PrimaryButton sx={{ px: 6, width: '100%' }} endIcon={<PictureAsPdfIcon style={{ color: '#FFF', mx: 1 }} />}>Imprimir</PrimaryButton>
        </Grid>
      </Grid>
      
      <Grid item xs={12} sx={{ mb: 4 }}>
        {
          ( table === 'room' ) ? 
            <DailyReportTable />
          : 
            <ServicesReport />
        }
      </Grid>
    </Grid>
  )
}

export default DailyReport